(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusRoutes', [
            'recomActionPlanUpdateStatusAssessRoutes',
            'recomActionPlanUpdateStatusReviewRoutes',
            'recomActionPlanUpdateStatusControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider
            .state('actionPlanUpdateStatusWelcome', {
                url: '/RecomActionPlanUpdateStatus/{BusinessUnitCode}/Welcome',
                resolve: {
                    businessUnit: ['recomService', '$stateParams', 'errorManagementService', function (recomService, $stateParams, errorManagementService) {

                        return recomService.getBusinessUnitByCode($stateParams.BusinessUnitCode)
                            .then(function (businessUnit) {
                                return businessUnit
                            }, function (response) {
                                errorManagementService.manageError(response)
                            })
                    }],
                    activeProcess: ['recomService', 'businessUnit', function (service, businessUnit) {
                        return service.getActiveGovernanceProcessByRecomBusinessUnit(businessUnit.RecomBusinessUnitID);
                    }]
                },
                views: {
                    '': {
                        templateUrl: require('./actionPlanUpdateStatus.tpl.html'),
                        controller: 'ActionPlanUpdateStatusController'
                    },
                    'mainContent@actionPlanUpdateStatusWelcome': {
                        templateUrl: require('./welcome.tpl.html'),
                        controller: 'ActionPlanUpdateStatusWelcomeController',
                        resolve: {
                            actionPlanLookups: ['recomActionPlanUpdateStatusService', function (service) {
                                return service.getActionPlanUpdateStatusLookups();
                            }]
                        }
                    }
                }
            })

            .state('actionPlanUpdateStatusOwnerList', {
                url: '/RecomActionPlanUpdateStatus/{BusinessUnitCode}/Owner',
                resolve: {
                    businessUnit: ['recomService', '$stateParams', 'errorManagementService', function (recomService, $stateParams, errorManagementService) {

                        return recomService.getBusinessUnitByCode($stateParams.BusinessUnitCode)
                            .then(function (businessUnit) {
                                return businessUnit
                            }, function (response) {
                                errorManagementService.manageError(response)
                            })
                    }],
                    activeProcess: ['recomService', 'businessUnit', function (service, businessUnit) {
                        return service.getActiveGovernanceProcessByRecomBusinessUnit(businessUnit.RecomBusinessUnitID);
                    }]
                },
                views: {
                    '': {
                        templateUrl: require('./actionPlanUpdateStatus.tpl.html'),
                        controller: 'ActionPlanUpdateStatusController'
                    },
                    'mainContent@actionPlanUpdateStatusOwnerList': {
                        templateUrl: require('./ownerList.tpl.html'),
                        controller: 'ActionPlanUpdateStatusOwnersListController',
                        resolve: {
                            actionPlanLookups: ['recomActionPlanUpdateStatusService', function (service) {
                                return service.getActionPlanUpdateStatusLookups();
                            }],
                            owners: ['recomActionPlanUpdateStatusService', 'activeProcess', function (service, businessUnit) {
                                return service.getOwnersAndStatus(businessUnit.RecomBusinessUnitID);
                            }]
                        }
                    }
                }
            })

            .state('actionPlanUpdateStatusSelectAssessment', {
                url: '/RecomActionPlanUpdateStatus/{BusinessUnitCode}/SelectAssessment',
                resolve: {
                    businessUnit: ['recomService', '$stateParams', 'errorManagementService', function (recomService, $stateParams, errorManagementService) {

                        return recomService.getBusinessUnitByCode($stateParams.BusinessUnitCode)
                            .then(function (businessUnit) {
                                return businessUnit
                            }, function (response) {
                                errorManagementService.manageError(response)
                            })
                    }],
                    activeProcess: ['recomService', 'businessUnit', function (service, businessUnit) {
                        return service.getActiveGovernanceProcessByRecomBusinessUnit(businessUnit.RecomBusinessUnitID);
                    }]
                },
                views: {
                    '': {
                        templateUrl: require('./actionPlanUpdateStatus.tpl.html'),
                        controller: 'ActionPlanUpdateStatusController'
                    },
                    'mainContent@actionPlanUpdateStatusSelectAssessment': {
                        templateUrl: require('./SelectAssessment.tpl.html'),
                        controller: 'ActionPlanUpdateStatusSelectAssessmentController',
                        resolve: {
                            actionPlanLookups: ['recomActionPlanUpdateStatusService', function (service) {
                                return service.getActionPlanUpdateStatusLookups();
                            }],
                            owners: ['recomActionPlanUpdateStatusService', 'activeProcess', function (service, businessUnit) {
                                return service.getOwnersAndStatus(businessUnit.RecomBusinessUnitID);
                            }]
                        }
                    }
                }
            });

        //historyCtxtServiceProvider.setCtxtState('aricControlOwnerList.byOwner',
        //    '/app/Main/initiativeUpdateStatus/GOVHistoryCtxtDirective-owner.tpl.html'
        //);
    }
})();